import registerForamTime from './format-time'

export default function registerDirectives(app) {
  registerForamTime(app)
}
